export function orderDistributionChannels(params: {
  selectedChannelIds?: string[];
  configuredChannelIds?: string[];
}): string[] {
  const { selectedChannelIds = [], configuredChannelIds = [] } = params;

  const selectedSet = new Set(selectedChannelIds);

  return configuredChannelIds.filter((channelId) => selectedSet.has(channelId));
}
